<div class="view-settings-dialog" style="width: 750px">
  <p style="text-align: justify;">{{ 'dialog.viewSettings.description' | translate }}</p>
  <div>
    <ul>
      <li *ngFor="let namedView of (namedViewsKeyValue$ | async)">
        {{ namedView.value.view.viewName }}
        <span *ngIf="namedView.value.view.isSystem" class="badge bg-orange">{{ 'components.settings.system' | translate }}</span>
        <span *ngIf="namedView.value.view.isDefaultView && !namedView.value.view.isSystem" class="badge bg-blue">{{ 'components.settings.default' | translate }}</span>
        <button 
          *ngIf="!namedView.value.view.isDefaultView && !namedView.value.view.isSystem" 
          class="small-icon-button link-like-button"
          (click)="deleteView(namedView.value.view.viewName)"
          title="{{ 'action.delete' | translate }}"
          aria-label="{{ 'action.delete' | translate }}">
          <i class="fas fa-trash-alt fa-sm" aria-hidden="true"></i>
        </button>
      </li>
    </ul>  
  </div>
</div>
